<template>
  <v-container id="filters-dialog">
    <!--//@*/*
        //    *RPD  App v0.91
        //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
        //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
        //    */
        //-->

    <v-dialog
      v-model="dialog"
      scrollable
      max-width="1200px"
      :fullscreen="$vuetify.breakpoint.mobile"
      :overlay-opacity="0.7"
      persistent
    >
      <v-card max-height="900px" class="backdrop dialog-card">
        <v-overlay absolute :value="overlay_loading">
          <v-progress-circular
            indeterminate
            :size="80"
            :width="7"
            color="secondary"
          ></v-progress-circular>
        </v-overlay>

        <v-card-title class="backdrop lighten-1 dialog-title">
          <span class="text-h5">Advanced Search</span>
        </v-card-title>
        <v-card-text class="backdrop pa-0 white--text">
          <v-container>
            <v-form v-model="valid" ref="form">
              <div class="backdrop lighten-1 pa-3 ma-0 elevation-1">
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      ref="search_field"
                      v-model="search_form.search_term"
                      label="Search Term"
                      hint="For valid date queries, please use a valid date format (e.g., 'YYYY-MM-DD')"
                    >
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-select
                      :items="divisions_list"
                      v-model="search_form.logtype"
                      label="Log Type"
                      placeholder="Select a log type"
                      maxlength="60"
                    >
                    </v-select>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <v-text-field
                      v-model="search_form.start_date"
                      type="date"
                      label="Incident Start Date"
                      :rules="[field_rules.date_range]"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    <v-text-field
                      v-model="search_form.end_date"
                      type="date"
                      label="Incident End Date"
                      :rules="[field_rules.date_range]"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <small
                      >Searches the last 30 days unless specified
                      otherwise.</small
                    >
                  </v-col>
                </v-row>
              </div>
            </v-form>
          </v-container>
          <!--<small class="mx-4">*indicates requireffd fields</small>-->
        </v-card-text>

        <v-card-actions class="backdrop lighten-1 border-card">
          <v-spacer></v-spacer>
          <v-btn color="secondary" class="black--text" @click="resetFilters">
            Reset
          </v-btn>
          <v-btn
            color="secondary"
            class="black--text"
            :disabled="!valid"
            @click="closeDialog"
          >
            Close
          </v-btn>
          <v-btn
            color="secondary"
            class="black--text"
            :disabled="!valid"
            @click="applyFilters"
          >
            Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../../scss/site.scss";

.dialog-card {
  box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;
}

.dialog-title {
  margin-bottom: 2px;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 28px,
    rgba(0, 0, 0, 0.22) 0px 10px 10px;
}

.custom-divider {
  height: 2px;
  background-color: black;
}

.border-card {
  margin: 2px;
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../../mixins/bus_common";
export default {
  name: "logs_search_dialog",
  mixins: [bus_common],
  props: ["search_form"],
  data() {
    return {
      dialog: true,
      overlay_loading: false,
      valid: false,
      field_rules: {
        required: (value) => !!value || "This field is required",
        min: (v) => v.length >= 8 || "Min 8 characters",
        max25: (v) => v.length <= 60 || "Max 60 characters",
        email: (value) => {
          const pattern =
            /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
          return pattern.test(value) || "Please provide a valid email address";
        },
        min_phone: (v) =>
          v.length >= 14 || "Please enter a complete phone number",
        phone: (value) => {
          const pattern =
            /^\d{3}(-|\s)\d{3}(-|\s)\d{4}$|^\d{10}$|^1\s\d{3}(-|\s)\d{3}(-|\s)\d{4}$|^(1\s?)?\(\d{3}\)(\s|\-)?\d{3}\-\d{4}$/;
          return pattern.test(value) || "Please provide a valid phone number";
        },
        filerequired: (value) => !!value || "A signature image is required",
        date_range: (value) => {
          var bool = false;
          if (
            this.search_form.start_date == "" &&
            this.search_form.end_date == ""
          ) {
            bool = true;
          } else if (
            this.search_form.start_date != "" &&
            this.search_form.end_date != ""
          ) {
            bool = true;
          } else {
            bool = false;
          }
          return bool || "A valid date range must be entered using both fields";
        },
      },
    };
  },
  methods: {
    closeDialog() {
      this.dialog = false;
      setTimeout(() => {
        this.$emit("closeDialog");
      }, 300);
    },
    resetFilters() {
      this.$emit("resetFilters");
      this.generate_filter_text();
    },
    async init() {
      this.overlay_loading = true;
      //await this.getUserData();
      this.overlay_loading = false;
      this.$refs.search_field.blur();

      if (this.search_form.start_date == "1900-01-01") {
        this.search_form.start_date = "";
      }

      if (this.search_form.end_date == "1900-01-01") {
        this.search_form.end_date = "";
      }
    },

    generate_filter_text() {
      this.filters_active_text = [];

      if (this.search_form.logtype != "") {
        let filter_text = {
          title: "LOG TYPE",
          value: this.search_form.logtype,
        };
        this.filters_active_text.push(filter_text);
      }

      if (
        this.search_form.start_date != "" ||
        this.search_form.start_date != ""
      ) {
        let sdate = "mm/dd/yyyy";
        let edate = "mm/dd/yyyy";

        if (this.search_form.start_date != "")
          sdate = this.$moment(
            new Date(this.search_form.start_date.replace(/-/g, "/"))
          ).format("MM/DD/YYYY");
        if (this.search_form.start_date != "")
          edate = this.$moment(
            new Date(this.search_form.start_date.replace(/-/g, "/"))
          ).format("MM/DD/YYYY");

        let filter_text = { title: "DATE RANGE", value: sdate + " - " + edate };
        this.filters_active_text.push(filter_text);
      }

      this.$emit("filterTextUpdated", this.filters_active_text);
    },

    applyFilters() {
      this.dialog = false;
      setTimeout(() => {
        this.$emit("applyFilters");
      }, 300);
    },
  },
  watch: {
    //Whenever object data changes emit new filter text
    search_form: {
      handler(val) {
        this.generate_filter_text();
        if (this.$refs.form) this.$refs.form.validate();
      },
      deep: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
  computed: {
    divisions_list() {
      if (this.$store.state.logDivisions.length > 0) {
        let AllArray = ["ALL"];
        let arrayMap = this.$store.state.logDivisions.map((d) => d.displayName);
        const combinedArray = [].concat(AllArray, ...arrayMap);
        return combinedArray;
      } else {
        return null;
      }
    },
  },
};
</script>
